import { render, staticRenderFns } from "./CoDropdown.vue?vue&type=template&id=c773c030&"
import script from "./CoDropdown.vue?vue&type=script&lang=ts&"
export * from "./CoDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CoDropdown.vue?vue&type=style&index=0&id=c773c030&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports